import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class InsuranceCompany extends Resource {
    public override type = 'insuranceCompanies';

    @prop()
    @required()
    public name!: string;    

}